import { render } from "./ExtranetSystemLog.vue?vue&type=template&id=63942876&scoped=true"
import script from "./ExtranetSystemLog.vue?vue&type=script&lang=js"
export * from "./ExtranetSystemLog.vue?vue&type=script&lang=js"

import "./ExtranetSystemLog.vue?vue&type=style&index=0&id=63942876&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63942876"]])

export default __exports__